import { Action } from 'redux';

import {GetPersonalSpace, GetPersonalSpaceSucceded } from '../../bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '../../bootstrap/redux/actions/isActionFactory';
import { PersonalSpaceInfo } from '../restApi/PersonalSpace';

export interface GetPersonalSpaceAction extends Action {
}

export interface GetPersonalSpaceSuccededAction extends Action {
  personalSpace: PersonalSpaceInfo;
}

export function getPersonalSpace(): GetPersonalSpaceAction {
  return {
    type: GetPersonalSpace
  };
}

export const isGetPersonalSpaceAction = isActionFactory<GetPersonalSpaceAction>(GetPersonalSpace);

export function getPersonalSpaceSucceded(result: PersonalSpaceInfo): GetPersonalSpaceSuccededAction {
  return {
    type: GetPersonalSpaceSucceded,
    personalSpace: result
  };
}

export const isGetPersonalSpaceSuccededAction = isActionFactory<GetPersonalSpaceSuccededAction>(GetPersonalSpaceSucceded);
